import * as actions from './actions';

// Default actions
export const toggleNav = (show) => ({
  type: actions.TOGGLE_NAV,
  show,
});


// WEBPACK FOOTER //
// ./src/store/actions/nav.js